import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { filter, map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HasRoleGuard implements CanLoad, CanActivate{

  constructor(private appService: AppService, private restService:RestService, private router:Router){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.hasRol(route);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.hasRol(route);
  }

  hasRol(route:Route): Observable<boolean>{
    const allowedRoles = route.data?.['allowedRoles'];
    return this.appService.currentUser$.pipe(
      filter(value => value !== null), // espera hasta que no sea null
      map((user) => Boolean(user && user.roles && user.roles.find(rol => allowedRoles.includes(rol)))),
      tap((hasRole) => hasRole === false && this.router.navigate(['/signin']) )
    );
  }
  

}
